import OfferedProposals from './OfferedProposals';

export default OfferedProposals;
